import React from 'react';
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';
import { BiSolidEnvelope } from "react-icons/bi";

const WebentwicklungHeader = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="mainbanner">
        <div className="web-development-banner">
          <div className="container">
            <div className="web-development-banner-content">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
              >
                <span>{t('webDevelopment_header_title1')}</span>
                <br />
                {t('webDevelopment_header_title2')}
              </h1>

              <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1200">
                {t('webDevelopment_header_description')}
              </p>

              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                <Link href="/kontakt" className="default-btn">
                  <BiSolidEnvelope />{t('webDevelopment_header_cta')}<span></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default WebentwicklungHeader;